import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { refresh } from './apis/refresh';
import { setTokens } from './setTokens';
import { emit, triggerError } from '../utils/eventManager';
import { getCookieDomain } from '../utils/config';
import { removeCookies } from '../utils/cookieManager';
import { getBroadcastChannel } from '../utils/broadcastChannel';
import { sendNewRelicEvent } from '../utils/newRelicEvents';
export { refreshToken, resolveOngoingRefresh, initOngoingRefresh };
var $ongoingRefresh;
var $resolve = function $resolve() {};
function refreshToken() {
  return _refreshToken.apply(this, arguments);
}
function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var tokens, idToken, accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window === 'undefined')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.prev = 2;
          if (!$ongoingRefresh) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", $ongoingRefresh);
        case 5:
          sendNewRelicEvent({
            EventName: 'refresh_start'
          });
          getBroadcastChannel().postMessage({
            action: 'refreshStart'
          });
          $ongoingRefresh = refresh();
          _context.next = 10;
          return $ongoingRefresh;
        case 10:
          tokens = _context.sent;
          idToken = tokens.idToken, accessToken = tokens.accessToken;
          $ongoingRefresh = null;
          getBroadcastChannel().postMessage({
            action: 'refreshEnd',
            payload: {
              tokens: tokens
            }
          });
          sendNewRelicEvent({
            EventName: 'refresh_success'
          });
          _context.next = 17;
          return setTokens({
            idToken: idToken,
            accessToken: accessToken,
            callInitSession: false,
            broadcast: true,
            authActionType: 'refresh_token'
          });
        case 17:
          return _context.abrupt("return", tokens);
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](2);
          $ongoingRefresh = null;
          if (_context.t0.code == 'invalid_grant') {
            sendNewRelicEvent({
              EventName: 'refresh_fail',
              reason: 'invalid grant'
            });
            removeCookies(getCookieDomain());
            emit('logout.success');
          } else {
            sendNewRelicEvent({
              EventName: 'refresh_fail',
              reason: _context.t0
            });
            triggerError('refresh', _context.t0);
          }
          getBroadcastChannel().postMessage({
            action: 'refreshEnd'
          });
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 20]]);
  }));
  return _refreshToken.apply(this, arguments);
}
function initOngoingRefresh() {
  $ongoingRefresh = new Promise(function (resolve) {
    $resolve = resolve;
  });
}
function resolveOngoingRefresh(tokens) {
  $ongoingRefresh = null;
  $resolve(tokens);
  $resolve = function $resolve() {};
}